import { Modal, Button } from 'antd';
import { t } from '@/utils/translator';
import i18n from '@/i18n';
import LanguageSwitcher from '@common/LanguageSwitcher';

const ProjectAnnouncementModal = ({ isVisible, onClose }) => {
  return (
    <Modal
      title={t('프로젝트 안내')}
      open={isVisible}
      onCancel={onClose}
      footer={[
        <div
          key="footer"
          style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}
        >
          <LanguageSwitcher />
          <Button onClick={onClose}>{t('닫기')}</Button>
        </div>,
      ]}
      centered
      className="my-4"
      width={'100%'}
      style={{ minWidth: '320px', maxWidth: '720px' }}
    >
      {i18n.language === 'ko' && (
        <div
          dangerouslySetInnerHTML={{
            __html: `<div>
              <h3>안녕하세요, HL만도 글로벌 협력사 온실가스 배출량 정보 등록 프로젝트에 참여해 주셔서 감사합니다. </h3>
              <br>   
              제출은 총 두 차례에 걸쳐 진행되며, 1차 제출 마감일은 8월 8일, 2차는 8월 29일입니다. 
              모든 기업은 반드시 1차 마감일(8월 8일)까지 자료를 제출해주시기 바라며, 제출된 자료에 대한 피드백이 제공된 후, 보완이 필요한 경우에는 2차 마감일(8월 29일)까지 수정본을 제출해 주십시오.
              <br>
              기간 내 제출이 어려우실 경우, 문의 채널을 통해 연락 주시면 기간 조정이 가능합니다.
              <br>
              <br>
              교육에 참석을 못하셨거나 다시 듣고 싶으신 분은 링크를 클릭하시면 교육 영상을 시청하실 수 있습니다.
              <br><br>
          
              <hr />
              <br>
              <div class="bg-red-2">
                <div class="bg-red-5 text-center py-1 px-3">
                  <h3 class="text-light mb-0">[온실가스 산정 템플릿 업데이트 안내 - 10/30]</h3>
                </div>
                
                <div class="p-3">
                  <div class="text-center fw-bold mb-3">
                    <u>일반 템플릿(version 5) 및 구버전용 템플릿(version 4)이 업데이트 되었습니다.</u>
                  </div>
                  <div class="mb-4">
                    <b>일부 수식이 수정되었으므로 정확한 결과 산출을 위해 새 버전의 템플릿을 다운받아 작성 부탁드립니다.</b> <br>
                    <b>주요 개선 사항:</b> <br>
                    - 제품 배출량 산정 수식 수정
                  </div>
                </div>
              </div>
              <br>
              <hr />
              <br>
              
              <div class="bg-yellow-4 border-gray-8 p-3 mb-1">
                내부 보안망을 사용할 경우 교육영상 접근이 제한될 수 있으니 접근에 어려움이 있는 경우 외부망 또는 핫스팟을 연결하여 접속 부탁드립니다.
              </div>
              <a target="_blank" href="https://youtu.be/G3I7DRwwdjU">HL 만도 협력사 온실가스 산정 교육</a>
              <br>
              <a target="_blank" href="https://youtu.be/lBw5RtjHF3Q">(한국어 음성, 영/중 자막)HL만도 협력사 템플릿 작성 가이드</a>
              </div>
              <br>

              <div style="background-color: #efefef; border-radius: 6px; padding: 0.5rem 1rem; font-size: 0.8rem;">
              <b>[문의 채널]</b><br>
              템플릿 또는 시스템 관련 문의는 시스템 화면 우측 하단의 &lt;문의하기&gt; 또는 이메일(<a href="mailto:carbon@qesg.co.kr" target="_blank">carbon@qesg.co.kr</a>)로 문의 주십시오. <br>
              - 문의처: (주)퀀티파이드이에스지 기후팀
              </div>
            </div>`,
          }}
        />
      )}

      {i18n.language === 'en' && (
        <div
          dangerouslySetInnerHTML={{
            __html: `<div>
              <h3>Hello, thank you for participating in the HL Mando Global Supplier GHG Emissions Information Registration Project.</h3>
              <br>
              We are pleased to share with you the <b>Greenhouse Gas Accounting Guide for HL Mando Suppliers (EU/IN)</b>, which will support you in preparing and submitting the required data. This guide has been designed to help suppliers align with international standards and ensure the accuracy and consistency of GHG emissions reporting.4
              <br>
              If you are unable to submit within the period, please contact us through the inquiry channel to adjust the schedule.
              <br><br>
              <div class="bg-yellow-4 border-gray-8 p-3 mb-1">
                If you are using an internal secure network, access to the training video may be restricted. In such cases, please try connecting via an external network or mobile hotspot.
              </div>
              <a target="_blank" href="https://youtu.be/2_a8cE5kK74">Greenhouse Gas Accounting Guide for HL Mando Suppliers(EU/IN)</a>
              <br>
              <a target="_blank" href="https://youtu.be/lBw5RtjHF3Q">(Korean Audio with English/Chinese Subtitles)HL Mando Supplier Template Guide</a>
              <br>
              <br>


              <hr />
              <br>
              <div class="bg-red-2">
                <div class="bg-red-5 text-center py-1 px-3">
                  <h3 class="text-light mb-0">[GHG Emissions Calculation Template Update Notice - Oct 30]</h3>
                </div>
                
                <div class="p-3">
                  <div class="text-center fw-bold mb-3">
                    <u>Template version 5 & Template for older excel version (ver.4) has been released.</u>
                  </div>
                  <div class="mb-5">
                    <u>As one of the formulas has been revised, please download and fill out the new version of the template to ensure accurate results.</u><br>
                    <b>Key improvements:</b> <br>
                    - Correction of a product emission calculation formula
                  </div>
                </div>
              </div>
              <br>
              <hr />
              <br>

              <div style="background-color: #efefef; border-radius: 6px; padding: 0.5rem 1rem; font-size: 0.8rem;">
              <b>[Inquiry Channel]</b><br>
              For inquiries regarding the template or system, please use the <Inquiry> button at the bottom right of the system screen or contact us via email (<a href="mailto:carbon@qesg.co.kr" target="_blank">carbon@qesg.co.kr</a>).<br>
              - Contact: Quantified ESG Climate Team
              </div>
          </div>
          `,
          }}
        />
      )}

      {i18n.language === 'zh' && (
        <div
          dangerouslySetInnerHTML={{
            __html: `<div>
              <h3>您好，感谢您参与 HL Mando 全球供应商温室气体排放量信息登记项目。</h3>
              <br>
              提交将分两次进行，第一次提交截止日期为8月8日，第二次为8月29日。
              所有企业必须在第一次截止日期（8月8日）之前提交资料。提交资料后将提供反馈，如需补充修改，请在第二次截止日期（8月29日）之前提交修订版本。
              <br>
              如无法在规定期限内提交，请通过咨询渠道联系我们，以调整提交时间。
              <br><br>
              如果您无法参加培训或想再次听培训，您可以点击链接观看培训视频。
              <br><br>
              <div class="bg-yellow-4 border-gray-8 p-3 mb-1">
                若您使用的是内部安全网络，可能会限制访问培训视频。若出现访问困难，请尝试连接外部网络或移动热点后重新访问。
              </div>
              <a target="_blank" href="https://youtu.be/QgG6t7uPddU">HL 万都供应商温室气体核算培训</a>
              <br>
              <a target="_blank" href="https://www.bilibili.com/video/BV1jVUzBoEY6/?share_source=copy_web&vd_source=75c045e4feb0616f135cea9fe5a52931">HL万都供应商模板填写指南（韩语音频，中文字幕）</a>
              <br><br>

              <hr />
              <br>
              <div class="bg-red-2">
                <div class="bg-red-5 py-1 px-3">
                  <h3 class="text-light text-center mb-0">[温室气体核算模板更新通知 - 10/30]</h3>

                  
                </div>

                <div class="bg-red-5 py-1 px-3">
                  <h3 class="text-light text-center mb-0">通用模板（ver 5）和旧版兼容模板（ver 4）已更新。</h3>

                  <div class="mb-2">
                    <b>由于其中一项公式已被修正，请下载新版本模板填写，以确保结果准确。<br>
                    <b>主要修订内容: </b> <br>
                    - 修正了产品排放量计算公式<br>
                  </div>
                </div>
              </div>
              <br>
              <hr />
              <br>

              <div style="background-color: #efefef; border-radius: 6px; padding: 0.5rem 1rem; font-size: 0.8rem;">
              <b>[咨询渠道]</b><br>
              关于模板或系统的咨询，请使用系统界面右下角的"咨询"按钮，或通过电子邮件(<a href="mailto:carbon@qesg.co.kr" target="_blank">carbon@qesg.co.kr</a>)与我们联系。<br>
              - 联系方式：Quantified ESG 气候团队
              </div>
          </div>
          `,
          }}
        />
      )}
    </Modal>
  );
};

export default ProjectAnnouncementModal;
